import { useResult } from 'src/composables/shared/Result'

export const AVAILABILITY_REASONS = Object.freeze({
  IS_NIL: 'isNil',
  IS_ARCHIVED: 'isArchived',
  IS_DISABLED_ON_SALES_CHANNEL: 'isDisabledOnSalesChannel',
  IS_SALES_DISABLED: 'isSalesDisabled',
  IS_SELECTION_REQUIREMENTS_UNMET: 'isSelectionRequirementsUnmet',
  IS_NOT_AVAILABLE_FOR_USER: 'isNotAvailableForUser',
  IS_NOT_AVAILABLE_NOW: 'isNotAvailableNow',
  IS_NOT_AVAILABLE_FOR_DATE: 'isNotAvailableForDate',
  IS_NOT_AVAILABLE_FOR_TIME: 'isNotAvailableForTime',
  IS_NOT_AVAILABLE_FOR_SHOWING: 'isNotAvailableForShowing',
  IS_NOT_AVAILABLE_FOR_SHOWING_DATE: 'isNotAvailableForShowingDate',
  IS_NOT_AVAILABLE_FOR_SHOWING_TIME: 'isNotAvailableForShowingTime',
  IS_NOT_AVAILABLE_FOR_DELIVERY_LOCATION: 'isNotAvailableForDeliveryLocation',
  IS_NOT_AVAILABLE_FOR_DELIVERY_TYPE: 'isNotAvailableForDeliveryType',
  IS_NOT_AVAILABLE_FOR_SHOWING_BADGES: 'isNotAvailableForShowingBadges',
  IS_NOT_DELIVERABLE: 'isNotDeliverable',
  IS_OUT_OF_STOCK: 'isOutOfStock'
})

const DEFAULT_AVAILABILITY_SCHEMA = Object.freeze({
  isAvailable: false,
  isValid: false,
  availableReason: null,
  availableMessage: null
})
/**
 *
 * @param {Object} schemaDefinition
 * @returns {Function}
 */
export function useAvailabilityResult (schemaDefinition = DEFAULT_AVAILABILITY_SCHEMA) {
  const { result } = useResult(schemaDefinition)

  return { result }
}
